import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { createContext } from 'react';
import withProps from "./with-props";
const {
  Provider,
  Consumer
} = createContext();
Provider.displayName = `ContextProvider`;
Consumer.displayName = `ContextConsumer`;

function withContext(a, b) {
  return Component => {
    if (a) Component = withProps(a, b)(Component); // Just render the component with props

    const WithContext = props => {
      return ___EmotionJSX(Consumer, null, context => ___EmotionJSX(Component, _extends({}, props, context)));
    };

    if (Component.name) {
      WithContext.displayName = `WithContext(${Component.name})`;
    }

    return WithContext;
  };
}

export { Provider, Consumer, withContext };